<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{servicePrintModel.serviceId}}" class="head col-12 col-lg-12">

                  <!-- Logo -->
                  <img id="logo-{{servicePrintModel.serviceId}}" [src]="logoEnterprise" alt=""
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!--Nit -->
                  <label id="t-nit-empresa-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-nit-empresa' | formatLabelPipe : elementsLabel}}</label>
                  <p id="nit-empresa-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{servicePrintModel.enterpriseNit}}</p>

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{servicePrintModel.enterpriseName}}</p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{servicePrintModel.branchName}}</p>

                  <!--Nombre Servicio -->
                  <p id="nombre-servicio-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'SERVICIO Nro.'+ servicePrintModel.consecutive}}</p>

                  <!--Estado  -->
                  <label id="t-estado-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-estado' | formatLabelPipe : elementsLabel}}</label>
                  <p id="estado-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{servicePrintModel.serviceState}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{servicePrintModel.branchAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' |formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{servicePrintModel.branchPhone}}</p>

                  <!-- Fecha Servicio -->
                  <label id="t-fecha-servicio-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha-servicio' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-servicio-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{servicePrintModel.dateService | date: 'dd/MM/yyyy'}}</p>

                  <!--C.Costos  -->
                  <label id="t-centro-costos-{{servicePrintModel.serviceId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-centro-costos' | formatLabelPipe : elementsLabel}}</label>
                  <p id="centro-costos-{{servicePrintModel.serviceId}}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{servicePrintModel.costCenter}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-obra-{{servicePrintModel.serviceId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion-obra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-obra-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{servicePrintModel.constructionSiteAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-obra-{{servicePrintModel.serviceId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono-obra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-obra-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{servicePrintModel.constructionSitePhone}}</p>

                  <!--Cliente  -->
                  <label id="t-cliente-{{servicePrintModel.serviceId}}" for="" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{servicePrintModel.constructionSiteClient}}</p>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-service-{{servicePrintModel.serviceId}}" [columns]="columns"
                  [data]="servicePrintModel.serviceDetails" [idMap]="idMap" [documentId]="servicePrintModel.serviceId"
                  [footerVisible]="true" [editFormat]="editFormat" (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <!-- Observaciones -->
          <div id="foot-{{servicePrintModel.serviceId}}" class="foot mt-1 container-observations">
            <!-- Observación Servicio -->
            <label id="t-observacion-servicio-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()" *ngIf="servicePrintModel.observation">
              {{'t-observacion-servicio' | formatLabelPipe : elementsLabel}}</label>
            <p id="observacion-servicio-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()" *ngIf="servicePrintModel.observation">{{servicePrintModel.observation}}
            </p>

            <!-- Firma Recibe-->
            <p id="linea-firma-recibe-{{servicePrintModel.serviceId}}" class="write-line" (click)="onClick()"
              (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
            <label id="t-linea-recibe-{{servicePrintModel.serviceId}}" (mousedown)="onMouseDown($event)"
              (dragstart)="onDragStart()">{{'t-linea-recibe' | formatLabelPipe : elementsLabel}}</label>
          </div>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{servicePrintModel.userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>